import { Injectable } from '@angular/core';
import { Data, ProductMovement } from '@mlc/types';
import { PositiveTransactionType, TransactionTypeEnum } from '../../models/enums/transactionTypeEnum';

@Injectable({
    providedIn: 'root',
})
export class ActivityFeedService {
    
    mergeWithdrawalsDeposits(
        ...args: { movements: Data<ProductMovement>[]; type: TransactionTypeEnum }[]
    ): (Data<ProductMovement> & { transactionType: TransactionTypeEnum; isPositive: boolean })[] {
        const allMovements: (Data<ProductMovement> & {
            transactionType: TransactionTypeEnum;
            isPositive: boolean;
        })[] = args.reduce((acc: (Data<ProductMovement> & { transactionType: TransactionTypeEnum; isPositive: boolean })[], arg) => {
            const isPositive: boolean = this.isPositive(arg.type);
            return acc.concat(
                arg.movements
                    .filter((movement) => movement && +movement.attributes.totalEuroValue)
                    .map((movement: Data<ProductMovement>) => {
                        return { ...movement, transactionType: arg.type, isPositive: isPositive };
                    })
            );
        }, [] as (Data<ProductMovement> & { transactionType: TransactionTypeEnum; isPositive: boolean })[]);
    
        return allMovements.sort((a: any, b: any) => {
            const date_a: Date = new Date(a.attributes.createdAt);
            const date_b: Date = new Date(b.attributes.createdAt);
            return date_b.getTime() - date_a.getTime();
        });
    }

    isPositive(transactionType: TransactionTypeEnum): boolean {
        return PositiveTransactionType.some((type) => type === transactionType);
    }
}
